import { Contract, Process } from "@/types/contract";
import { RequestStatusType } from "@/constants/request";

export const isValidRequestStatus = (contract?: Contract) =>
  contract?.requestStatus === RequestStatusType.EDITING || contract?.requestStatus === RequestStatusType.SAVED;

export const isContractCheck = (contract: Contract, isContractRequest: boolean) =>
  contract.process === Process.PS && isContractRequest && !isValidRequestStatus(contract);

export const isRequestCanceled = (contract: Contract) =>
  [
    RequestStatusType.CANCELED_BY_NEW_CUSTOMER,
    RequestStatusType.CANCELED_BY_OLD_CUSTOMER,
    RequestStatusType.CANCELED_BY_OPERATOR,
    RequestStatusType.REJECTED,
  ].includes(contract.requestStatus as RequestStatusType);

export const isRequestExpired = (contract: Contract) =>
  [RequestStatusType.EXPIRED_SUBMITTED, RequestStatusType.EXPIRED_UNFINISHED].includes(
    contract.requestStatus as RequestStatusType
  );
